export const DOCUMENT_TYPE_FONT = 'commerce.font';
export const DOCUMENT_TYPE_FONT_COLLECTION = 'commerce.fontCollection';
